__turbopack_context__.v({
  "accordionRoot": "accordionSection-module__Tlt9RG__accordionRoot",
  "answer": "accordionSection-module__Tlt9RG__answer",
  "blockquote": "accordionSection-module__Tlt9RG__blockquote",
  "codeBlock": "accordionSection-module__Tlt9RG__codeBlock",
  "contentHeader": "accordionSection-module__Tlt9RG__contentHeader",
  "heading1": "accordionSection-module__Tlt9RG__heading1",
  "heading2": "accordionSection-module__Tlt9RG__heading2",
  "heading3": "accordionSection-module__Tlt9RG__heading3",
  "heading4": "accordionSection-module__Tlt9RG__heading4",
  "heading5": "accordionSection-module__Tlt9RG__heading5",
  "heading6": "accordionSection-module__Tlt9RG__heading6",
  "headingFallback": "accordionSection-module__Tlt9RG__headingFallback",
  "inlineBold": "accordionSection-module__Tlt9RG__inlineBold",
  "inlineBoldItalic": "accordionSection-module__Tlt9RG__inlineBoldItalic",
  "inlineCode": "accordionSection-module__Tlt9RG__inlineCode",
  "inlineItalic": "accordionSection-module__Tlt9RG__inlineItalic",
  "inner": "accordionSection-module__Tlt9RG__inner",
  "link": "accordionSection-module__Tlt9RG__link",
  "list": "accordionSection-module__Tlt9RG__list",
  "listItem": "accordionSection-module__Tlt9RG__listItem",
  "listOrdered": "accordionSection-module__Tlt9RG__listOrdered",
  "listUnordered": "accordionSection-module__Tlt9RG__listUnordered",
  "paragraph": "accordionSection-module__Tlt9RG__paragraph",
  "triggerAlign": "accordionSection-module__Tlt9RG__triggerAlign",
  "triggerHeading": "accordionSection-module__Tlt9RG__triggerHeading",
});
